// extracted by mini-css-extract-plugin
export default {"dialog":"ReviewsModal_dialog__qwE8H"};